<script>
    //tras o componente que fazer o loop para montar o menu dinamico independe dos itens
    import ListMenu from './navmenu/listmenu.vue'

            export default{
                data: function () {
                    return{
                        links:
                                []
                    }
                },
                components:
                        {
                            ListMenu
                        },
                watch:{
                    $route(){
                        var windowWidth = window.innerWidth;

                        if(windowWidth < 1005){
                            $('html, body').stop().animate({
                                scrollTop: $('.page-content-wrapper').offset().top
                            }, 200);
                        }else{
                            $('html, body').stop().animate({
                                scrollTop: '0px'
                            }, 200);
                        }
                    }

                },
                ready: function ()
                {

					setTimeout(function(){
									var itens = $('.sub-menu').find('.v-link-active').parents('li')
									$(itens[itens.length - 1]).find('a').trigger('click')
									$('.sub-menu').find('.v-link-active').trigger('click')
								}, 1000)

                    $.ajaxSetup({
                        async: false
                    });

					var urlAtual = window.location.href.split('/');
					var covid = false
					
					for(var c = 0;c < urlAtual.length; c++){
						if(urlAtual[c] == 'covid') {
							covid = true
						}
					}

					var options = {
						covid: covid
					}
                    var self = this;
                    //json com os dados do menu
                    $.getJSON('./server/acoes.php', options, function (links)
                    {
                        window.menuJson = links;
                        self.links = links;
                    });

                    $.ajaxSetup({
                        async: true
                    });


                    var t = setInterval(function () {

                        if ($('.page-sidebar').length > 0) {
                            Layout.init();
                            Demo.init();

                            $('ul>li>a').click(function () {

                                if ($(this).attr('target') == '_blank') {
                                    window.open($(this).attr('href'));
                                }

                                
                            });

                            clearInterval(t);
                        }

                    }, 200);

                }
            }

</script>

<template>


    <ul class="page-sidebar-menu " data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200">
        <!--                <li class="heading visible-lg visible-md">
                            <a href="javascript:;" class="sidebar-toggler">
                                <i class="fa fa-reorder"></i>
                            </a>
                        </li>-->
        <list-menu v-for="item in links" :line="item"></list-menu>
    </ul>

</template>

<style>


</style>


// WEBPACK FOOTER //
// navmenu.vue?2ef26421